<template>
  <div :class="{ big_wrap: showWriteAddress == true }">
    <top-header-info></top-header-info>
    <top-logo state="1"></top-logo>
    <!-- <right-nav></right-nav> -->
    <home-nav></home-nav>
    <div>
      <div class="w">
        <div class="site-nav">
          <router-link :to="{ name: 'index' }">首页</router-link>>
          <router-link :to="{ name: 'user-center' }">个人中心</router-link>>
          地址管理
        </div>
        <left-userinfo state="2"></left-userinfo>
        <div class="right-address-wrap">
          <div class="title">
            <h2>地址管理</h2>
          </div>
          <address-list @showMask="showMask"></address-list>
        </div>
      </div>
    </div>
    <bottom-content></bottom-content>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import RightNav from "@/components/right-nav";
import BottomContent from "@/components/bottom-content";
import HomeNav from "@/components/home-nav";
import LeftUserinfo from "@/components/left-userinfo";
import AddressList from "@/components/address-list";
export default {
  components: {
    TopHeaderInfo,
    TopLogo,
    RightNav,
    BottomContent,
    HomeNav,
    LeftUserinfo,
    AddressList
  },
  data() {
    return {
      showWriteAddress: false
    };
  },
  methods: {
    showMask(data) {
      if (!data) {
        this.showWriteAddress = false;
      } else {
        this.showWriteAddress = true;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.big_wrap {
  height: 100vh;
  overflow: hidden;
}
.site-nav {
  padding: 20px 0;
  color: #999;
  font-size: 16px;
  a {
    color: #999;
  }
  a:first-child {
    color: #444;
  }
}
.right-address-wrap {
  // position: relative;
  margin-bottom: 40px;
  min-height: 572px;
  width: 980px;
  margin-left: 220px;
  box-sizing: border-box;
  padding: 10px 25px 0;
  background-color: #fff;
  .title {
    line-height: 42px;
    height: 42px;
    border-bottom: 2px solid #dadada;
    margin-bottom: 30px;
    h2 {
      width: 120px;
      border-bottom: 2px solid #e2333f;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      box-sizing: border-box;
      padding-left: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-address.vue